<template>
  <template v-if="inclFB">VistaCentros: beg template<br></template>
  <div>
    <ModalEditHorasGlobal :open="modalhorastate" @updateRangoHoras="updateRangoHoras" @close="closeEditModalHoras" />

    <ModalMapaFaenas :showModalMapa="showModalMapa" :propIdFaena="this.idFaena" @close="closeModal"> </ModalMapaFaenas>
    <ModalLayoutJaulas :showModalLayout="showModalLayout" :propIdFaena="this.idFaena" @close="closeModalLayout">
    </ModalLayoutJaulas>
    <MenuAyuda :showModalAyuda="showModalAyuda" @close="closeModalAyuda"></MenuAyuda>
    <ModalVisibilidad :objJaulas="objJaulas" :showModalVisibilidad="showModalVisibilidad" @close="closeModalVisibilidad"
      @handleVisibilidad="handleVisibilidad"></ModalVisibilidad>
    <ModalRangoFechas :propIdFaena="propIdFaena" :showModalVisibilidad="showModalRangoFechas"
      @close="closeModalRangoFechas" @handleRangoFechas="handleRangoFechas"></ModalRangoFechas>

    <div class="grid xs:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-1">
      <div class="container mx-auto  p-1">

        <!-- Ini nombre faena y fechas/horas de faena y de usuario -->
        <div class="ml-0 w-full">
          <div class="text-left text-base text-black">
            <span class="ml-0 font-bold">
              Live {{ $t('centro') }} {{ nombreFaena }}
            </span>
            <span class="ml-5">
              <b>{{ $t('origen') }}:</b> {{ fechahoraActual }}
            </span>
            <span class="ml-2">
              <b> Local:</b> {{ fechahoraLocal }}
            </span>
          </div>
        </div>
        <!-- Fin nombre faena y fechas/horas de faena y de usuario -->

        <!-- Ini planta, entorno y botones -->
        <div class="flex flex-wrap lg:flex-nowrap mt-1">

          <!-- Ini planta y entorno -->
          <div class="w-full lg:w-2/3 pl-0">
            <div class="container">

              <!-- Ini planta -->
              <div class="w-full grid   bg-white pl-2 rounded-lg shadow mb-1">

                <div class="flex items-left justify-left pt-2   text-sm font-medium  w-full ">
                  <span v-html="$t('planta')"></span>
                </div>

                <div class="w-full grid lg:grid-cols-4 sm:grid-cols-2  grid-cols-2  gap-2 bg-white p-2  ">

                  <div
                    class="flex items-center justify-center p-2 bg-blue-400 text-white text-sm font-medium rounded-md">
                    {{ $t('estado') }}
                  </div>
                  <div class="flex items-center pl-2 text-sm">
                    <a href="#">{{ estado_planta }}</a>
                  </div>

                  <div
                    class="flex items-center justify-center p-2 bg-blue-400 text-white text-sm font-medium rounded-md">
                    {{ $t('modo') }}
                  </div>
                  <div class="flex items-center pl-2 text-sm">
                    <a href="#">{{ modo_planta}} </a>
                  </div>

                  <div
                    class="flex items-center justify-center p-2 bg-blue-700 text-white text-sm font-medium rounded-md">
                    <span v-html="$t('flujo_oxigeno')"></span>
                  </div>
                  <div class="flex items-center pl-2 text-sm">
                    <a href="#">{{ flujoo2 }} {{ flujoo2_ume }}</a>
                  </div>

                  <div
                    class="flex items-center justify-center p-2 bg-blue-700 text-white text-sm font-medium rounded-md">
                    <span v-html="$t('pureza_oxigeno')"></span>
                  </div>
                  <div class="flex items-center pl-2 text-sm text-gray-900 hover:text-gray-600">
                    <a href="#">{{ purezao2 }} {{ purezao2_ume }}</a>
                  </div>

                </div>

              </div>
              <!-- Fin planta -->

              <!-- Ini entorno -->
              <div class="w-full grid   bg-white p-1 rounded-lg shadow mb-1">

                <div class="flex items-left justify-left p-1   text-sm font-medium  w-full ">
                  <span v-html="$t('entorno')"></span>
                </div>

                <div class="w-full grid lg:grid-cols-4 sm:grid-cols-2 grid-cols-2 gap-2 bg-white p-1 pl-3">

                  <div class="flex items-center justify-center p-2 bg-green-500 text-white text-sm font-medium rounded-md">
                    {{ $t('salinidad') }}
                  </div>
                  <div class="flex items-center pl-2 text-sm">
                    <a href="#">{{ salinidad }} {{ salinidadume }} </a>
                  </div>

                  <div class="flex items-center justify-center p-2 bg-green-500 text-white text-sm font-medium rounded-md">
                    O<sub>2</sub>&nbsp;Natural
                  </div>
                  <div class="flex items-center pl-2 text-sm text-gray-900 hover:text-gray-600">
                    <a href="#">{{ o2natural }} {{ o2naturalume }}</a>
                  </div>

                </div>

              </div>
              <!-- Fin entorno -->

            </div>
          </div>
          <!-- Fin planta y entorno -->

          <!-- Ini segunda sección: botones cal hor vis inf -->
          <div class="w-full lg:w-1/3 pl-8 pr-2 text-center pt-2">
            <div class="grid grid-cols-4 sm:grid-cols-4 md:grid-cols-4 gap-2 p-0">

              <a href="#" class="group flex flex-col items-center justify-between 
              p-2 rounded-lg transition duration-150 ease-in-out hover:bg-gray-50" @click="loadModalRangoFechas(true)">
                <div   class="flex-shrink-0 inline-flex h-12 w-12 sm:h-12 sm:w-12 items-center justify-center rounded-md bg-indigo-500 text-white">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-8 h-8">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M8 2v2M16 2v2M3 8h18M5 4h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2z" />
                  </svg>
                </div>
                <p class="text-xs text-gray-900 mt-1"> {{ $t('calendario') }}</p>
              </a>

              <btnHoras @emitModalEditHorasGlobal="loadModalEditHorasGlobal" />

              <a href="#"
                class="group flex flex-col items-center justify-between p-2 rounded-lg transition duration-150 ease-in-out hover:bg-gray-50"
                @click="loadModalVisibilidad(true)">
                <div
                  class="flex-shrink-0 inline-flex h-11 w-12 sm:h-12 sm:w-12 items-center justify-center rounded-md bg-indigo-500 text-white">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-8 h-8">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M2.458 12C3.732 7.943 7.522 5 12 5c4.478 0 8.268 2.943 9.542 7-.034.096-.07.192-.106.287C20.268 16.057 16.478 19 12 19c-4.478 0-8.268-2.943-9.542-7-.036-.095-.072-.191-.106-.287z" />
                  </svg>
                </div>
                <p class="text-xs text-gray-900"> {{ $t('visibilidad') }}</p>
              </a>

              <a href="#"   class="group flex flex-col items-center justify-between p-2 rounded-lg transition duration-150 ease-in-out hover:bg-gray-50"    @click="loadAyuda()">
                <div
                  class="flex-shrink-0 inline-flex h-11 w-12 sm:h-12 sm:w-12 items-center justify-center rounded-md bg-indigo-500 text-white">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-8 h-8">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                  </svg>
                </div>
                <p class="text-xs text-gray-900"> {{ $t('informacion') }}</p>
              </a>

            </div>
          </div>
          <!-- Fin segunda sección: botones cal hor vis inf -->

        </div>
        <!-- Fin planta, entorno y botones -->


        <!-- Ini estados -->
        <div class="estados">

        <template v-if="inclLS">

          <!-- Ini estado módulo -->
          <div class="estado_modulo grid   bg-white p-1 rounded-lg shadow mb-1">
            <div class="flex items-left justify-left p-1   text-sm font-medium  w-full ">
              <!-- <span v-html="$t('modulo')"></span> -->
              <!-- <span>{{ $t('modulo') }}</span> -->
              <span>Estado del Módulo</span>
            </div>
            <div class="healthModuleContainer">
              <LedSegments :segment="healthModuleStatus"></LedSegments>
            </div>
          </div>
          <!-- Fin estado módulo -->

          <!-- Ini estado jaulas -->
          <div class="estado_jaulas grid   bg-white p-1 rounded-lg shadow mb-1">
            <div class="flex items-left justify-left p-1   text-sm font-medium  w-full ">
              <!-- <span v-html="$t('jaulas')"></span> -->
              <!-- <span>{{ $t('jaulas') }}</span> -->
              <span>Estado de las Jaulas</span>
            </div>
            <template v-if="inclFB">VistaCentros: healthStatuses={{ healthStatuses }}.<br></template>
            <div class="healthUnitContainer">
              <template v-if="false">
                <LedSegments v-for="objJaula in objJaulas" :key="objJaula" :segment="0"></LedSegments>
              </template>
              <LedSegments v-for="healthStatus in healthStatuses" :key="healthStatus" :segment="healthStatus"></LedSegments>
            </div>
          </div>
          <!-- Fin estado jaulas -->

        </template> <!-- inclLS -->

        <!-- <template v-if="inclFB">VistaCentros: healthDataSets={{ healthDataSets }}.<br></template> -->

        <template v-if="inclPJ">
              <!-- Ini promedios jaulas -->
              <div class="w-full grid   bg-white p-1 rounded-lg shadow mb-1">

                <div class="flex items-left justify-left p-1   text-sm font-medium  w-full ">
                  <span v-html="$t('modulo')"></span>
                </div>

                <div class="w-full grid lg:grid-cols-4 sm:grid-cols-2 grid-cols-2 gap-2 bg-white p-1 pl-3">

                  <div
                    class="flex items-center justify-center p-2 bg-green-700 text-white text-sm font-medium rounded-md">
                    <!-- O<sub>2</sub>&nbsp;Natural -->
                    Saturación de O<sub>2</sub>
                  </div>
                  <div class="flex items-center pl-2 text-sm text-gray-900 hover:text-gray-600">
                    <!-- <a href="#">{{ o2natural }} {{ o2naturalume }}</a> -->
                    <a href="#">{{ healthModuleDataAverage(healthDataSets, 6) }} %</a>
                  </div>

                  <div
                    class="flex items-center justify-center p-2 bg-green-700 text-white text-sm font-medium rounded-md">
                    <!-- {{ $t('salinidad') }} -->
                    O<sub>2</sub>&nbsp;Disuelto
                  </div>
                  <div class="flex items-center pl-2 text-sm">
                    <!-- <a href="#">{{ salinidad }} {{ salinidadume }} </a> -->
                    <a href="#">{{ healthModuleDataAverage(healthDataSets, 5) }} mg/L</a>
                  </div>

                </div>

              </div>
              <!-- Fin promedios jaulas -->

        </template> <!-- inclPJ -->

        </div>
        <!-- Fin estados -->


        <div class="w-full">
          <SimbolosJaulas />
        </div>

      </div>
    </div>

    <!-- Ini gráficos jaulas -->
    <div class="bg-white">
      <div class="flex flex-wrap">
        <div class="w-full ">

          <div v-if="dataLoaded == false" class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1 mt-8">
            {{ $t('cargando_jaulas') }} ...
          </div>

          <template v-if="inclFB">VistaCentros: healthStatuses={{ healthStatuses }}<br></template>
          <GraficosLiveCentros :idEmpresa="idEmpresa" :propIdFaena="propIdFaena" :propObjJaulas="objJaulas"
            :invervalohoras="invervalohoras" :propRangoFechas="objRangoFechas"
            @healthDataSetsUpdate="healthDataSets=$event"
            @healthStatusesUpdate="healthStatuses=$event"
            >
          </GraficosLiveCentros>
          <template v-if="inclFB">VistaCentros: healthStatuses={{ healthStatuses }}<br></template>

        </div>
      </div>
    </div>
    <!-- Fin gráficos jaulas -->

  </div>
  <template v-if="inclFB">VistaCentros: end template<br></template>
</template>

<style scoped>
footer {
  z-index: 5000;
  width: 900px;
  height: 86px;
  padding-top: 4px;
  padding-bottom: 6px;
}
header {
  padding-top: 2px;
  z-index: 5000;
  width: 300px;
  height: 200px;
  margin-left: 200px;
}
.health-1-Container {
  display: flex;
  gap: 12px;
  padding: 16px;
  width: 100%;
  height: 100vh;
  overflow-x: auto;
}
.health-2-Container {
  display: flex;
  height: 4.5em;
  width: 50%;
  gap: 12px;
  padding: 16px;
  overflow-x: auto;
}
.health-3-Container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(1ch, 6ch));
  gap: 1rem;
  padding: 1rem;
  height: 4em;
  align-items: stretch;
  width: 100%;
  overflow: hidden;
}
.healthModuleContainer {
  display: flex;
  gap: 1px;
  padding: 0.35rem 0.75rem;
  width: 100%;
  height: 60px;
}
.healthModuleContainer > * {
  max-width: 7ch;
  height: 100%;
  flex: 1 1 auto;
  min-width: 1px;
  overflow: hidden;
}
.healthUnitContainer {
  display: flex;
  gap: 1px;
  padding: 0.35rem 0.75rem;
  width: 100%;
  height: 60px;
}
.healthUnitContainer > * {
  max-width: 5ch;
  height: 100%;
  flex: 1 1 auto;
  min-width: 1px;
  overflow: hidden;
}
.estados {
  display: flex;
  flex-direction: row;
  width: 66.6667%;
  gap: 4px;
}
.estado_modulo {
  flex: 4;
}
.estado_jaulas {
  flex: 11;
}
@media (max-width: 1023px) {
  .estados {
    flex-direction: column;
    width: 100%;
  }
  .estado_modulo, .estado_jaulas {
    flex: none;
    width: 100%;
  }
}
</style>

<script>
import axios from "axios";
//import i18n from '@/i18n';
import GraficosLiveCentros from "./GraficosLiveCentros";
import ModalMapaFaenas from "../resumen/modal/ModalMapaFaenas";
import ModalLayoutJaulas from "../resumen/modal/ModalLayoutJaulas";
import ModalVisibilidad from "./modal/ModalVisibilidad";
import ModalRangoFechas from "./modal/ModalRangoFechas";
import MenuAyuda from "./MenuAyuda";
 
 
import btnHoras from "./ui/btnHoras";
import ModalEditHorasGlobal from "./modal/ModalEditHorasGlobal";
import SimbolosJaulas from "./ui/SimbolosJaulas.vue";
//import {  mapGetters  } from 'vuex'
import LedSegments from "./viewers/LedSegments.vue";

export default {
  name: "FaenasCliente",
  props: ["idEmpresa", "propIdFaena", "nombreFaena", "numRam"],
  emits: ['chgFaena', 'handleDropFaena'],
  components: {
    GraficosLiveCentros, ModalLayoutJaulas,  
    ModalMapaFaenas, MenuAyuda, ModalVisibilidad,  
    ModalRangoFechas, btnHoras, ModalEditHorasGlobal, SimbolosJaulas,
    LedSegments
  },
/*   computed: {
  ...mapGetters(['getStateInyeccionTrue']),
 }, */
  computed: {
    healthModuleStatus() {
      const valores=Object.values(this.healthStatuses);
      if(valores.length>0) {
        return Math.min(...valores);
      }
      return null;
    }
  },
  mounted() {

    const setpoints = this.$store.state.login.userLogin.info.default_setpoints;
    let resultado = setpoints.find(item => item.idPar === 5);
    this.o2naturalume = resultado ? resultado.unMedida : null;


    let f = this.$store.state.faenas;
    let obj = f.faenas.filter(item => item.id === this.idFaena);
    if (Array.isArray(obj[0].unidades)) {
      let objJaulas = obj[0].unidades.filter(unidad => unidad.tipo == "Plataforma" && unidad.natural == 'S');

      if (objJaulas && typeof objJaulas === 'object') {

        this.unidadNatural = objJaulas[0].id;

        const firstJaula = objJaulas[0];
        if (firstJaula && firstJaula.id && Array.isArray(firstJaula.sensores) && firstJaula.sensores.length === 0) {




          let sensorbuscado = objJaulas[0].sensores[0];
          const parametro_sensores = this.$store.state.login.userLogin.info.parametro_sensores;
          let sensor_aquatrol = parametro_sensores.filter(sensor => sensor.id == sensorbuscado)
          let salinidad = [];
          if (Array.isArray(sensor_aquatrol) && sensor_aquatrol.length > 0 && Array.isArray(sensor_aquatrol[0].parametros)) {
            salinidad = sensor_aquatrol[0].parametros.filter(parametro => parametro.id == 2);
            if (salinidad.length > 0) {
              this.salinidadume = salinidad[0].unidad;
            }
          }

        }


      }
    }


 
    this.idFaena = this.propIdFaena;
    this.loadUnidades()
    this.loadUnidades_natural()
    this.fechahora();
    this.getCoordenadas();
    this.getdataSondaAquaTroll();
    this.revisaInyecciones();
    this.polldata();
    this.pollHora();
    this.pollInyecciones();
  },
  data() {
    return {
      o2natural: '--',
      o2naturalume: '',
      salinidad: '--',
      salinidadume: 'PSU',
      unidadNatural: 'mg/l',
      orp: 0,
      purezao2: ' ---.--',
      purezao2_ume: '--',
      flujoo2: ' ---.--',
      flujoo2_ume: '',  
      estado_planta: '',    
      modo_planta: '',   
      idParamSalinidad: 2,
      idParamO2Natural: 5,
      invervalohoras: 0,
      inclFB: false, // feedback
      inclLS: false, // Led Segments
      inclPJ: true, // Promedios Jaulas
      seriesLoaded: false,
      dataLoaded: false,
      datos_mensuales: [],
      faenas: [{}],
      cards: [{}],
      objFaenas: [{}],
      seriesFaenas: [],
      modalhorastate: false,
      numRamdom: this.numRam,
      showModalMapa: false,
      showModalLayout: false,
      showModalAyuda: false,
      unidadTipoPlanta: {},
      idFaena: this.propIdFaena,
      objJaulas: [],
      objJaulasVisibles: [],
      showModalVisibilidad: false,
      showModalRangoFechas: false,
      fechahoraActual: '',
      fechahoraLocal: '',
      tieneCoordenadas: false,
      objRangoFechas: {},
      polling:{},
      polling2:{},
      polling3:{},
      healthDataSets: {},
      healthStatuses: {},
    };
  },
  methods: {
    polldata() {
      this.polling = setInterval(() => {

        this.getdataSondaAquaTroll();
      }, 15000); //
    },
    pollHora() {
      this.polling2 = setInterval(() => {
        // this.getdataendpoint_endesuso() ;
        this.fechahora()
      }, 1);
    },
    pollInyecciones(){
      this.polling3 = setInterval(()=>{
        this.revisaInyecciones()
      },5000);
    },
    updateRangoHoras(valor) {
      this.modalhorastate = false;
      this.invervalohoras = valor;
    },
    loadModalEditHorasGlobal() {
      this.modalhorastate = true;
    },
    async revisaInyecciones() {
      const apiKey = this.$store.state.login.tokenLogin;
      const data = {
        idFaena: this.idFaena,

      };

      const fetchData = async () => {
        try {
          const url = "/api/mon/getPlantData";
          const response = await axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `${apiKey}`
            }
          });


          const params = response.data.payload;
        

          this.flujoo2 = params.plant.flow[0] ? params.plant.flow[0]: ' ---.--';
          this.flujoo2_ume = params.plant.flow[1]

          this.purezao2 = params.plant.purity[0] ? params.plant.purity[0]: '--.-';
          this.purezao2_ume = params.plant.purity[1]

          this.estado_planta= params.plant.state ?  params.plant.state : '---'
          this.modo_planta= params.plant.mode ?  params.plant.mode : '---'

        } catch (error) {
          console.error("Error al obtener datos:", error);
          return false;
        }
      };


      fetchData().then(() => {



      }).catch(error => {
        console.error("Error processing data:", error);
      });


      //console.log('inyeccion',inyeccion)
    },
    async getdataSondaAquaTroll() {
      let objFecha = this.$store.getters.fechaHoraActual(this.propIdFaena);
      const y = objFecha.getFullYear;
      const m = String(objFecha.getMonth).padStart(2, '0');
      const d = String(objFecha.getDate).padStart(2, '0');

      const h = String(objFecha.getHours).padStart(2, '0');
      const min = String(objFecha.getMinutes).padStart(2, '0');
      const s = String(objFecha.getSeconds).padStart(2, '0');

      //let objFechaHora = DateTime.fromObject(
      //  { year: y, month: m, day: d, hour: h, minute: min, second: s },
      //  { zone: 'America/Santiago' }
      //);

      this.fFinal = `${y}-${m}-${d}T${h}:${min}:${s}`;

      let objFechaHora = this.$store.getters.dateFactory(this.fFinal, this.propIdFaena);
      let minuto_en_ms = 1 * 60 * 1000;
      let fInicial = objFechaHora.subtractMillis(minuto_en_ms);
      fInicial = fInicial.split('.')[0];

      //console.log('aquatroll', `${fInicial}`, `${this.fFinal}`)

      const apiKey = this.$store.state.login.tokenLogin;
      const data = {
        idUnit: this.unidadNatural,
        tsi: `${fInicial}`,
        tsf: `${this.fFinal}`,
        granularity: ``
      };

      const fetchData = async () => {
        try {
          const url = "/api/mon/getUnitData";
          const response = await axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `${apiKey}`

            }
          });

          //console.log('aquatrol', data);

          const params = response.data.payload.sensors[0].params;



          let obj = params.filter(param => param.id === this.idParamSalinidad);
          if (Array.isArray(obj)) {
            let values = [...obj[0].values].splice(-1);
            this.salinidad = values[0].value ? values[0].value : '-.--';
          }
          obj = params.filter(param => param.id === this.idParamO2Natural);
          if (Array.isArray(obj)) {
            let values = [...obj[0].values].splice(-1);
            this.o2natural = values[0].value ? values[0].value : '-.--';
          }


        } catch (error) {
          console.error("Error al obtener datos:", error);
          return false;
        }
      };

      fetchData().then(() => {


        this.result_mediciones = true;

      }).catch(error => {
        console.error("Error processing data:", error);
      });


    },
    getCoordenadas() {
      let objStoreFaenas = this.$store.state.faenas;
      this.objFaena = objStoreFaenas.faenas.filter(faena => faena.id == this.propIdFaena);
      if (Array.isArray(this.objFaena) && this.objFaena.length > 0) {

        let longitud = this.objFaena[0]["longitud"];
        let latitud = this.objFaena[0]["latitud"];
        if (longitud && latitud) {
          this.tieneCoordenadas = true;
        }
      }
    },
    loadModalVisibilidad(valor) {
      //console.log("modifica estado modal");
      this.showModalVisibilidad = valor;
    },
    loadModalRangoFechas(valor) {
      //console.log("modifica estado modal");
      this.showModalRangoFechas = valor;
    },
    handleVisibilidad() {
      // this.$emit("handleDropFaena");
      //console.log('handle visibilidad jaula')
      this.loadUnidades()
      this.$emit("handleDropFaena");
    },
    handleRangoFechas(valor) {
      //console.log('handleRangoFecs', valor)

      this.objRangoFechas = valor;
      this.showModalRangoFechas = false;

    },
    getRnd(min, max) {
      let flot = Math.random() * (max - min + 1) + min;

      return flot.toFixed(2)
    },
    loadMapa() {
      //console.log('LOAD MAPA')
      this.showModalMapa = true
    },
    loadLayout() {
      //console.log('LOAD LAYOUT')
      this.showModalLayout = true
    },
    loadAyuda() {
      //console.log('LOAD AYUDA')
      this.showModalAyuda = true
    },
    closeModal() {
      this.showModalMapa = false
    },
    closeModalLayout() {
      this.showModalLayout = false
    },
    closeModalAyuda() {
      this.showModalAyuda = false
    },
    closeModalVisibilidad() {
      this.showModalVisibilidad = false;
    },
    closeModalRangoFechas() {
      this.showModalRangoFechas = false;
    },
    closeEditModalHoras() {
      this.modalhorastate = false;
    },
    fechahora() {

      this.objFechaActual = this.$store.getters.fechaHoraActual(this.propIdFaena);
      this.fechahoraActual = `${this.objFechaActual.fechaHora}  (${this.objFechaActual.zoneName})`;

      const ahora = new Date();
      const dia = String(ahora.getDate()).padStart(2, '0');
      const mes = String(ahora.getMonth() + 1).padStart(2, '0');
      const anio = ahora.getFullYear();

      const horas = String(ahora.getHours()).padStart(2, '0');
      const minutos = String(ahora.getMinutes()).padStart(2, '0');
      const segundos = String(ahora.getSeconds()).padStart(2, '0');
      const zonaHoraria = Intl.DateTimeFormat().resolvedOptions().timeZone;

      this.fechahoraLocal = `${dia}-${mes}-${anio} ${horas}:${minutos}:${segundos} (${zonaHoraria})`;


    },

    loadUnidades() {
      let storeVacio = true;
      //console.log('storeJaulas', this.$store.state.jaulas.Jaulas)
      if (this.$store.state.jaulas.Jaulas.length > 0) {
        this.storeJaulas = this.$store.state.jaulas;
        storeVacio = false;
      }

      this.f = this.$store.state.faenas;
      let obj = this.f.faenas.filter(item => item.id === this.idFaena);
      if (Array.isArray(obj[0].unidades)) {
        this.objJaulas = obj[0].unidades.filter(unidad => unidad.natural !== "S");
        //this.objJaulas = obj[0].unidades.filter(unidad => unidad.id == "1101");

        if (Array.isArray(this.objJaulas)) {

          this.objJaulasVisibles = this.objJaulas.map(jaula => {

            if (!storeVacio) {
              let arrayJaula = this.storeJaulas.Jaulas.filter(store => store.id == jaula.id && store.visible == false);
              //console.log('revisa:', jaula.id, arrayJaula.length)
              if (arrayJaula.length > 0) {

                jaula.visible = false;

              } else {
                jaula.visible = true;
              }



            } else {
              // no existe jaula en el store visibilidad jaulas
              jaula.visible = true;

              // this.$store.dispatch("jaulaAdd", jaula);
              return jaula;
            }


          });


        }

        this.dataLoaded = true;
      }

      this.healthDataSets = {};
      this.healthStatuses = {};

    },
    loadUnidades_natural() {
      this.o2natural = '--';
      this.orp = '--';

      let objJaulas = []
      let f = this.$store.state.faenas;
      let obj = f.faenas.filter(item => item.id === this.idFaena);
      if (Array.isArray(obj[0].unidades)) {
        objJaulas = obj[0].unidades.filter(unidad => unidad.natural == 'S');


        if (objJaulas && typeof objJaulas === 'object') {


          const jaula = objJaulas[0];
          if (jaula && 'id' in jaula) {
            this.unidadTipoPlanta.id = jaula.id;
          }
          if (jaula && 'sensores' in jaula) {
            this.unidadTipoPlanta.sensores = jaula.sensores;
          }

        }
      }
    },
    healthModuleDataAverage(hDS, idPar) {
      const values = Object.values(hDS)
        .flat()
        .filter(obj => obj.idPar === idPar)
        .map(obj => parseFloat(obj.measu))
        .filter(num => !isNaN(num));
      const average = values.length === 0 ? null : values.reduce((a, b) => a + b, 0) / values.length;
      return average !== null ? average.toFixed(2) : '--:--';
      // En el futuro, tener despliegue por defecto dependiente de la un.med. lg.
    },
  },
  beforeUnmount() {
    clearInterval(this.polling);
    clearInterval(this.polling2);
    clearInterval(this.polling3);
  },
  watch: {

    propIdFaena: function (value) {
      this.dataLoaded = false;
      this.idFaena = value;
      this.loadUnidades();
      this.loadUnidades_natural();
    }
  }


};
</script>
